export default "__VITE_ASSET__BnDQ2RsA__"